import React, { useMemo } from 'react'
import _ from 'lodash'

import S from './styled'

import Step from './step'

const StepDetails = ({
  selectedStep,
  handleTranslationChange,
  locales, defaultLocale,
  stepsModel,
  ingredients,
  field,
  appliance,
  locked,
}) => {

  const { parentStep, parentStepPath } = useMemo(() => {
    if (selectedStep && selectedStep.includes('replacements')) {
      const parentStepPath = `values[${field}].${selectedStep.split('.replacements')[0]}`
      const parentStep = _.get(stepsModel.model, parentStepPath)
      return {
        parentStep,
        parentStepPath,
      }
    }
    return {}
  }, [field, selectedStep, stepsModel.model])

  return  (
    <S.StepDetails>
      {
        selectedStep ? (
          <Step {...{
            selectedStep,
            handleTranslationChange,
            locales, defaultLocale,
            stepsModel,
            field,
            ingredients,
            appliance,
            parentStep,
            parentStepPath,
            locked,
          }} />
        ) : <S.Placeholder>Please select Step to customize</S.Placeholder>
      }
    </S.StepDetails>
  )
}

export default StepDetails
